import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled from 'styled-components'
import Subheader from 'components/Subheader'
import {
  BreadcrumbsContainer,
  FootprintsContainer,
  CustomerSwitcherContainer
} from 'containers'
import Navigation from './Navigation'
import { useKendra } from '../../hooks'

const TopLine = styled.div`
  min-height: 60px;
  background: #eeeeee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;

  .logo {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    
    .logo {
      justify-content: space-between;
      padding-top: 10px;
    }
  }
`

const Container = styled.div`
  min-width: 100%;
  height: 100%;
`
const LogoSP = styled(Link)`
  height: 50px;
  width: 155px;
  background-image: ${props => props.customerLogo ? props.customerLogo : 'url(https://s3.amazonaws.com/tpassets.devicebits.com/SupportPredictLogo.svg)'};
  background-size: contain;
  background-repeat: no-repeat;
`
const NavigationContainer = styled.div `
  padding: 10px 10px;

  @media only screen and (max-width: 768px) {
    padding: 0;
    margin-top: 20px;
    margin-bottom: 20px;
  }
`
const Header = ({
  handleHomeClick,
  auth,
  showNotes,
  showCallHandler,
  location,
  isStarted,
  getOption,
  ...props
}) => {
  const { isKendraEnabled } = useKendra()
  let customerLogo = getOption('styles.logoLink') || getOption('search.fivestar.logoLink')
  if (
    customerLogo &&
    (
      !customerLogo.startsWith('url(') ||
      customerLogo.startsWith('http')
    )
  ) {
    customerLogo = `url(${customerLogo})`
  }
  return (
    <Container>
      <TopLine>
        <div className="logo">
          <LogoSP customerLogo={customerLogo} to="/" onClick={handleHomeClick} />
          {(isStarted || !showCallHandler) && (
            <CustomerSwitcherContainer dark />
          )}
        </div>
        <NavigationContainer>
          <Navigation
            auth={auth}
            handleHomeClick={handleHomeClick}
            showCallHandler={showCallHandler}
            location={location}
            isKendraEnabled={isKendraEnabled}
            {...props}
          />
        </NavigationContainer>
      </TopLine>
      <Subheader
        showNotes={showNotes}
        showCallHandler={showCallHandler}
        location={location}
        isKendraEnabled={isKendraEnabled}
        getOption={getOption}
        {...props}
      />
      <BreadcrumbsContainer />
      <FootprintsContainer />
    </Container>
  )
}

Header.propTypes = {
  handleHomeClick: PropTypes.func.isRequired,
  showNotes: PropTypes.bool,
  showCallHandler: PropTypes.bool,
  location: PropTypes.string.isRequired,
  isStarted: PropTypes.bool.isRequired,
  auth: PropTypes.object.isRequired
}
export default Header
